/*eslint-disable */
import {mapGetters} from 'vuex';
export default {
  name: 'comment-on-video-list',
  components: {},
  props: ['currentVideoData'],
  data () {
    return {
      selfUserInfoData:null,
      commentTextarea:'',
      commentButtonGroup:false,
      isSubmitted:false,
      getCurrentVideoDataState:null,
      commentListData:null,
      commentListResults:[]
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters',
    ]),
    getSelfUserInfoDataFun() {
      this.selfUserInfoData = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
    getCurrentVideoData(){
      return this.currentVideoData;
    }
  },
  mounted () {
    this.getCurrentVideoDataState = this.currentVideoData
    this.getSelfUserInfoDataFun
    this.getCommentListOfVideoByIDMethod(this.currentVideoData)
  },
  methods: {
    getCommentListOfVideoByIDMethod(data){
      this.$store.dispatch('getCommentOnVideoByIDFun', {id:data.snippet.resourceId.videoId}).then((res) => {
        this.commentListData = res.data.data
        this.commentListResults = this.commentListData.results 
      }).catch((err)=>{
      })
    },
    commentButtonGroupEnabled(){
      this.commentButtonGroup = true
    },
    commentButtonGroupDisabled(){
      this.commentButtonGroup = false
      this.commentTextarea = ''
    },
    commentPostOnVideoMethod(){
      this.isSubmitted = true
      let payload = {
        item_id:this.currentVideoData.snippet.resourceId.videoId,
        user: this.selfUserInfoData.id,
        comment:this.commentTextarea
      }
      this.$store.dispatch('postCommentOnVideoFun', payload).then((res) => {
        this.isSubmitted = false
        this.commentTextarea = ''
        this.getCommentListOfVideoByIDMethod(this.getCurrentVideoDataState)
      }).catch((err) => {

      })
    }
  },
  watch:{
    getSelfUserInfoDataFun(){
      return this.$store.getters.acUserDetailsStateGetters.data
    },
    getCurrentVideoData(newVal, oldVal){
      this.getCurrentVideoDataState = newVal
      this.getCommentListOfVideoByIDMethod(newVal)
    }
  }
}